import React from "react";
import { attentIcon } from "./SVG";

export default function Tool(props) {
  return (
    <div className="tool">
      <div className="tool__btn">{attentIcon}</div>
      <div className="tool__text">{props.text}</div>
    </div>
  );
}
